import {
    SimulationCalculationOptionValue,
    SimulationCalculationRecord,
    SimulationCalculationResultRecord,
    SimulationResultContract
} from "./TradeSimulationRecords";
import {Optional} from "../../js/util/Optional";

export class SimulationCalculationResult {

    private constructor(public readonly simulationId: number,
                        private readonly record: SimulationCalculationResultRecord) {
    }

    public get from(): string {
        return this.record.from;
    }

    public get to(): string {
        return this.record.to;
    }

    public get summaries(): Array<SimulationCalculationRecord> {
        return this.record.summaries;
    }

    public contractFor(code: string, tradeDate: string): Optional<SimulationResultContract> {
        const contract = this.record.contracts.find(c => c.code === code && c.tradeDate === tradeDate);
        return Optional.of(contract);
    }

    public optionValuesForDate(date: string): Optional<Array<SimulationCalculationOptionValue>> {
        return Optional.of(this.record)
                       .map(rec => rec.summaries)
                       .map(summ => summ.find(s => s.asAt === date))
                       .map(s => s.optionValues);
    }

    public static create(simulationId: number, record: SimulationCalculationResultRecord): SimulationCalculationResult {
        return new SimulationCalculationResult(simulationId, record);
    }
}
